module.exports = __webpack_public_path__ + "static/media/Portrait-10208.58c47429.jpg";